import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';

const SingleImage = ({ data, onEdit }) => {
    const { image, imageStyle = {}, style = {} } = data || {};

    return (
        <ModuleBase onEdit={onEdit} style={style}>
            <div style={{ width: '100%' }}>
                {image ? (
                    <img
                        src={image}
                        alt=""
                        style={{
                            display: 'block',
                            maxWidth: '100%',
                            ...imageStyle
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: '100%',
                            height: '160px',
                            background: 'var(--semi-color-fill-2)',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'var(--semi-color-text-2)'
                        }}
                    >
                        请上传图片
                    </div>
                )}
            </div>
        </ModuleBase>
    );
};

export default SingleImage;